export default {
  created_date: 'добавлено',
  updated_date: 'изменено',
  videos_count: 'видео',
  participants_count: 'участники',
  status: 'статус',
  creator: 'создатель'
};
